import request from '../static/js/request'
import { getformData } from '@/static/js/zjs'

/**
 * IM
 */

// 获取IM的登陆密码
export const getSig = function(userId) {
  return request.post('/mopa/api-internet-user/open/tencent/cloud/im/genUserSig', {
    user_id: userId
  })
}

/**
 * 直播间
 */

// 查询直播间基础信息
export const getLiveRoomInfo = function(liveRoomId) {
  return request
    .get(`/mopa/api-checking/open/liveroom/info/${liveRoomId}?rts_template=_pa-RTS`)
    .then((res) => res.data)
}

export const getIMGroupInfo = function(liveRoomId) {
  return request
    .get(`/mopa/api-internet-user/open/tencent/cloud/im/getGroupInfo`, {
      params: {
        room_id: liveRoomId
      }
    })
    .then((res) => res.data)
}

/**
 * 拍照提问
 */
// 用户拉取我的待解答
export const getNumberOfMyWaitingQuesiont = function({ roomId, appid, openid }) {
  return request
    .get(`/mopa/api-checking/open/liveroom/user/question/my/wait/number`, {
      params: {
        room_id: roomId,
        appid,
        openid
      }
    })
    .then((res) => res.data)
}

// 前方等待
export const getMyQuestionRanking = function({ roomId, appid, openid }, haveNoAnsweredQeustion) {
  // 有待解答问题
  if (haveNoAnsweredQeustion) {
    return request
      .get(`/mopa/api-checking/open/liveroom/queue/my/rank`, {
        params: {
          room_id: roomId,
          appid,
          openid
        }
      })
      .then((res) => res.data)
  } else {
    return request
      .get(`/mopa/api-checking/open/liveroom/queue/wait/number`, {
        params: {
          room_id: roomId,
          appid,
          openid
        }
      })
      .then((res) => res.data)
  }
}

// 提交 拍照提问
export const askQuestion = function({
  appid,
  openid,
  questionImg,
  userLevel,
  nick,
  avatar,
  source,
  sourceId,
  liveroomId,
  questionDesc,
  followStatus
}) {
  const obj = {
    appid,
    openid,
    userLevel,
    nick,
    avatar,
    source,
    liveroomId,
    questionDesc,
    followStatus: followStatus ? 1 : 0
  }
  if (source === 'book') {
    obj.sourceId = sourceId
    obj.questionDesc = ''
  }
  const data = getformData(obj)
  if (questionImg) {
    data.append('file', questionImg)
  }
  return request.post('/mopa/zuul/api-checking/open/liveroom/user/question/save', data)
}

// 删除 拍照提问
export const deleteQuestion = function({ appid, openid, id }) {
  return request.post('/mopa/api-checking/open/liveroom/user/question/save', {
    appid,
    openid,
    id
  })
}

// C端--查询用户提问列表
export const getQuestionList = function(params) {
  return request.get('/mopa/api-checking/open/liveroom/queue/wait/list', {
    params
  })
}
// C端--查询用户提问列表
export const getMyQuestionList = function(params) {
  return request.get('/mopa/api-checking/open/liveroom/user/question/list', {
    params
  })
}
// C端--保存历史
export const saveUserHistory = function({
  appid,
  openid,
  nick,
  avatar,
  userLevel,
  liveroomId, // 直播间
  comeFrom // 标识从哪里跳转到直播间的
}) {
  return request.post('/mopa/api-checking/open/liveroom/user/history/save', {
    appid,
    openid,
    nick,
    avatar,
    userLevel,
    liveroomId, // 直播间
    comeFrom // 标识从哪里跳转到直播间的
  })
}

// C端查询用户提问数据
export const getQuestionStatusNumber = function({ roomId, appid, openid }) {
  return request
    .get(`/mopa/api-checking/open/liveroom/user/question/my/number`, {
      params: {
        room_id: roomId,
        appid,
        openid
      }
    })
    .then((res) => res.data)
}

// 查询单个用户提问详情
export const getQuestionDetail = function(questionId) {
  return request
    .get(`/mopa/api-checking/open/liveroom/user/question`, {
      params: {
        id: questionId
      }
    })
    .then((res) => res.data)
}

// C端-删除提问
export const deleteQuestionById = function({ id, appid, openid }) {
  return request
    .post('/mopa/api-checking/open/liveroom/user/question/deleteById', {
      id,
      appid,
      openid
    })
    .then((res) => res.data)
}

// 获取视频的数据
export const getPlayInfo = async function(videoId) {
  return request({
    method: 'get',
    url: `/mopa/api-checking/open/aliyun/video/getPlayInfo`,
    params: {
      videoId
    }
  })
}
// 获取互动答题详情
export function getAnswerQuesInfoById(id) {
  return request({
    method: 'get',
    url: `/mopa/api-answer-card/open/question_bank/findById`,
    params: {
      id
    }
  })
}
// 用户提交答案
/** {
    "appid":"appid",
    "openid":"openid",
    "nickname":"nickname",
    "headimgurl":"headimgurl",
    "vipLevel":"vipLevel",
    "timeConsuming":5,
    "option":[2]
}
*/
export function postUserAnswer(id, data) {
  return request({
    method: 'post',
    url: `/mopa/api-answer-card/open/question_bank/answer/${id}`,
    data
  })
}
// 点赞
export function postUserLike(data) {
  return request({
    method: 'post',
    url: `/mopa/api-answer-card/open/question_bank/like`,
    data
  })
}
// 查看排行榜
export function getAnswerRanking(id) {
  return request({
    method: 'get',
    url: `/mopa/api-answer-card/open/question_bank/ranking/${id}`
  })
}
